import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { axios } from '@/common/axios';
import { MutationConfig, queryClient } from '@/common/react-query';
import { STRIPE_CURRENT_CUSTOMER_INFO_QUERY_KEY } from '@/config';

import { UpdateStripeCustomerPayload, UpdateStripeCustomerResponse } from './types';

export const patchUpdateStripeCustomer = (
    payload: UpdateStripeCustomerPayload
): Promise<UpdateStripeCustomerResponse> => {
    return axios.patch('/api/v2/customers/profile', payload);
};

type UseUpdateStripeCustomerProfile = {
    config?: MutationConfig<typeof patchUpdateStripeCustomer>;
    data?: UpdateStripeCustomerPayload;
};

export const useUpdateStripeCustomerProfile = ({ config }: UseUpdateStripeCustomerProfile = {}) => {
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: patchUpdateStripeCustomer,
        onSuccess: (response) => {
            queryClient.invalidateQueries({
                queryKey: [STRIPE_CURRENT_CUSTOMER_INFO_QUERY_KEY],
                refetchType: 'all',
            });
            /*
                If subscription was in past_due state before updating customer default payment method,
                it may have changed to active after successful payment with a new payment method.
             */
            queryClient.invalidateQueries({ queryKey: ['stripe-invoices-list'] });
            queryClient.invalidateQueries({ queryKey: ['stripe-updated-quantity-upcoming-invoice'] });
            queryClient.invalidateQueries({ queryKey: ['stripe-subscription-info'] });
            mixpanel?.track('Stripe customer profile updated', {
                stripeCustomerId: response.data.stripe_customer_id,
            });
        },
    });
};
